import request from "@/utils/requestJSON";

export function buildTwcaCertificateUrl(config) {
  const serial = config && config.serialNumber;
  // Accept strings only: certificate serials exceed safe integer precision.
  if (typeof serial !== "string" || !/^\d+$/.test(serial.trim())) return "";
  // expiresOn is an internal note only; it never controls the link.
  return "https://ssl2.twca.com.tw/NCWebSSL/certinfo.htm?DNS=www.tmnewa.com.tw&SerialNumber="
    + encodeURIComponent(serial.trim()) + "&lang=zh";
}

export function getTwcaCertificateUrl() {
  return request({
    url: "/storage/Config/TwcaCertificate.json",
    method: "get",
    params: { _t: Date.now() },
  }).then((response) => buildTwcaCertificateUrl(response.data));
}
